import Box from "@mui/material/Box";
import {FormControlLabel} from "@mui/material";
import StyledCheckBox from "../CommonComponents/StyledCheckbox/StyledCheckBox";
import StyledRangeSlider from "../CommonComponents/StyledRangeSlider/StyeledRangeSlider";
import React, {useEffect} from "react";
import {useTheme} from "../../contexts/theme";
import {EventOfInterest, skills, Settings} from "../../types/jobDataTypes";


interface KeyMomentJobComponentProps {
    eventOfInterest : EventOfInterest;
    onSliderChange : (fieldName: 'start' | 'end', value: number) => void;
    onFieldChange: (fieldName: keyof EventOfInterest, fieldValue: string | boolean) => void
    showAutoPublication: boolean;
    disableComponent?: boolean
}

function valueLabelFormat(minutes: number) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = Math.floor(minutes % 60);

    const formattedMinutes = String(hours).padStart(2, '0');
    const formattedSeconds = String(remainingMinutes).padStart(2, '0');


    if ((formattedSeconds) === "31") {
        return "Auto";
    }

    return `${formattedMinutes}:${formattedSeconds}`;
}

export default function KeyMomentJobComponent ({eventOfInterest, onFieldChange, onSliderChange, showAutoPublication, disableComponent}: KeyMomentJobComponentProps) {
    const theme = useTheme();

    return (
        <Box sx={{
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom:1,
            borderColor: theme.palette.lightGrey,
            borderWidth:theme.border.width.medium ,
            display:"flex",
        }}>

            <Box sx={{
                alignItems: 'center',
                justifyContent: 'space-between',
            }}>
                <FormControlLabel
                    sx={{
                        color: theme.palette.white,
                        opacity: disableComponent ? 0.5 : 1,
                        width: "100%", // Imposta una larghezza
                        paddingRight: "none",
                        '&.Mui-disabled .MuiFormControlLabel-label': {
                            color: theme.palette.lightGrey,
                        },
                    }}
                    control={
                        <StyledCheckBox
                            disabled={disableComponent}
                            checked={eventOfInterest.included!}
                            iconSize={"25px"}
                            onChange={(e) => {onFieldChange('included', (e.target as any).checked)}}
                        />
                    }
                    label={"Include"}
                />
            </Box>
            <Box
                sx={{
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width:"100%",
                    pointerEvents: disableComponent !== undefined ? (eventOfInterest.included && disableComponent ? 'none' :  eventOfInterest.included ? 'auto' : 'none') : eventOfInterest.included ? 'auto' : 'none' ,
                    opacity: disableComponent !== undefined ? (eventOfInterest.included && disableComponent ? 0.5 : eventOfInterest.included  ? 1 : 0.5) : eventOfInterest.included  ? 1 : 0.5 ,
                }}>
                <StyledRangeSlider
                    value={[eventOfInterest.start as number,eventOfInterest.end as number]}
                    onChange={(_, newValue, activeThumb) => onSliderChange((activeThumb === 0 ? 'start' : 'end'), Array.isArray(newValue) ? newValue[activeThumb] : newValue)}
                    min={-31}
                    max={31}
                    centredInterval={true}
                    valueLabelDisplay={"auto"}
                    formatLabel={(value) => valueLabelFormat(Math.abs(value))}
                    labelSlider={eventOfInterest.key_moment}
                    centerValue={5}
                    minLabel={"Start"}
                    maxLabel={"End"}
                />
            </Box>
            { !(skills as any)[eventOfInterest.key_moment] ? (
                <Box sx={{
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    display: 'flex',
                    pointerEvents: eventOfInterest.included ? 'auto' : 'none',
                    opacity: eventOfInterest.included ? 1 : 0.5,
                }}>
                    <Box sx={{
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}>
                        {eventOfInterest.hasOwnProperty('replay') && <FormControlLabel
                            sx={{
                                color: theme.palette.white,
                                width: "100%", // Imposta una larghezza
                            }}
                            control={
                                <StyledCheckBox
                                    checked={eventOfInterest.replay}
                                    height={"20px"}
                                    width={"20px"}
                                    iconSize={"25px"}
                                    onChange={(e) => onFieldChange('replay', (e.target as any).checked)}
                                />
                            }
                            label={"Replay"}
                        />}
                        <Box hidden={!(eventOfInterest.key_moment === 'GOAL' || eventOfInterest.key_moment === 'CARD')}>
                            <FormControlLabel
                                sx={{
                                    color: theme.palette.white,
                                    width: "100%",
                                }}
                                control={
                                    <StyledCheckBox
                                        checked={eventOfInterest.var}
                                        height={"20px"}
                                        width={"20px"}
                                        iconSize={"25px"}
                                        onChange={(e) => {onFieldChange('var', (e.target as any).checked)}}
                                    />
                                }
                                label={"Var"}
                            />
                        </Box>
                    </Box>
                </Box>
            ) : (
                <Box sx={{
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    pointerEvents: eventOfInterest.included ? 'auto' : 'none',
                    opacity: eventOfInterest.included ? 1 : 0.5,
                }}>
                    <></>
                </Box>
            )
            }
            <Box sx={{
                alignItems: 'center',
                justifyContent: 'space-between'
            }}>
                {showAutoPublication && (
                    <Box sx={{
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        pointerEvents: eventOfInterest.included ? 'auto' : 'none',
                        opacity: eventOfInterest.included ? 1 : 0.5,
                    }}>
                        <FormControlLabel
                            sx={{
                                color: theme.palette.white,
                                width: "100%", // Imposta una larghezza
                                marginLeft: theme.spacing.sm,
                                '&.Mui-disabled .MuiFormControlLabel-label': {
                                    color: theme.palette.lightGrey,
                                },
                            }}
                            control={
                                <StyledCheckBox
                                    disabled={!eventOfInterest.included}
                                    checked={Boolean(eventOfInterest.auto_publication)}
                                    height={"20px"}
                                    width={"20px"}
                                    iconSize={"25px"}
                                    onChange={(e) => onFieldChange('auto_publication', (e.target as any).checked)}
                                />
                            }
                            label={"Auto Publication"}
                        />
                    </Box>
                )}
            </Box>
        </Box>
    )
}




